<footer class="footer">
    <div class="container-fluid">
        <div class="copyright float-right">
            &copy;
            {{ date | date: 'yyyy' }} Sequens IT (v{{ appVersion }})
        </div>
    </div>
</footer>
